export const { default: Label } = require("./Label");
export const { default: LabelForm } = require("./LabelForm");